"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@home-health-notify/domain");
const labRequisitionUiSchema = {
    type: "VerticalLayout",
    elements: [
        {
            type: "Group",
            label: "Lab",
            elements: [
                {
                    type: "Control",
                    scope: "#/properties/labInformation/properties/labId",
                },
            ],
        },
        {
            type: "Group",
            label: "Panel Information",
            elements: [
                {
                    type: "Control",
                    scope: "#/properties/tests",
                },
            ],
        },
        {
            type: "Group",
            label: "Specimen Information",
            elements: [
                {
                    type: "VerticalLayout",
                    elements: [
                        {
                            type: "Control",
                            label: "Requisition Type",
                            scope: "#/properties/specimenInformation/properties/requisitionType",
                            options: {
                                format: "radio",
                            },
                        },
                        {
                            type: "HorizontalLayout",
                            elements: [
                                {
                                    type: "Control",
                                    label: "Collection Date",
                                    scope: "#/properties/specimenInformation/properties/collectionDate",
                                },
                                {
                                    type: domain_1.RenderersUIType.TimePicker,
                                    label: "Collection Time (ET)",
                                    options: {
                                        timeFormat: "HH:mm:ss",
                                        showUnfocusedDescription: true,
                                    },
                                    scope: "#/properties/specimenInformation/properties/collectionTime",
                                },
                            ],
                        },
                        {
                            type: "Control",
                            label: "Collection Frequency",
                            scope: "#/properties/specimenInformation/properties/collectionFrequency",
                            options: {
                                format: "radio",
                            },
                            rule: {
                                effect: "SHOW",
                                condition: {
                                    scope: `#/properties/specimenInformation/properties/requisitionType`,
                                    schema: {
                                        const: "Standing Order",
                                    },
                                },
                            },
                        },
                        {
                            type: "Control",
                            label: "Recure Order Days",
                            scope: "#/properties/specimenInformation/properties/collectionDays",
                            rule: {
                                effect: "SHOW",
                                condition: {
                                    scope: `#/properties/specimenInformation/properties/requisitionType`,
                                    schema: {
                                        const: "Standing Order",
                                    },
                                },
                            },
                        },
                        {
                            type: "Control",
                            label: "Termination Date",
                            scope: "#/properties/specimenInformation/properties/terminationDate",
                            rule: {
                                effect: "SHOW",
                                condition: {
                                    scope: `#/properties/specimenInformation/properties/requisitionType`,
                                    schema: {
                                        const: "Standing Order",
                                    },
                                },
                            },
                        },
                    ],
                },
            ],
        },
        {
            type: "Group",
            label: "Comments",
            elements: [
                {
                    type: "Control",
                    label: "Comments",
                    scope: "#/properties/comments",
                },
            ],
        },
        {
            type: "Group",
            label: "ICD Codes",
            elements: [
                {
                    type: "Control",
                    scope: "#/properties/diagnosis",
                },
            ],
        },
        {
            type: "Group",
            label: "Provider",
            elements: [
                {
                    type: domain_1.RenderersUIType.NPIInput,
                    label: "Provider NPI",
                    scope: "#/properties/providerInformation/properties/providerNPI",
                },
            ],
        },
        {
            type: "Group",
            label: "Patient Information",
            elements: [
                {
                    type: "VerticalLayout",
                    elements: [
                        {
                            type: "HorizontalLayout",
                            elements: [
                                {
                                    type: "Control",
                                    label: "First Name",
                                    scope: "#/properties/patientInformation/properties/firstName",
                                },
                                {
                                    type: "Control",
                                    label: "Last Name",
                                    scope: "#/properties/patientInformation/properties/lastName",
                                },
                            ],
                        },
                        {
                            type: "HorizontalLayout",
                            elements: [
                                {
                                    type: "Control",
                                    label: "Gender",
                                    scope: "#/properties/patientInformation/properties/gender",
                                    options: {
                                        format: "radio",
                                    },
                                },
                            ],
                        },
                        {
                            type: "HorizontalLayout",
                            elements: [
                                {
                                    type: "Control",
                                    label: "Date of Birth",
                                    scope: "#/properties/patientInformation/properties/dateOfBirth",
                                },
                                {
                                    type: "Control",
                                    label: "Room No",
                                    scope: "#/properties/patientInformation/properties/roomNo",
                                },
                            ],
                        },
                        {
                            type: "Control",
                            label: "Address 1",
                            scope: "#/properties/patientInformation/properties/addressOne",
                        },
                        {
                            type: "Control",
                            label: "Address 2",
                            scope: "#/properties/patientInformation/properties/addressTwo",
                        },
                        {
                            type: "HorizontalLayout",
                            elements: [
                                {
                                    type: "Control",
                                    label: "City",
                                    scope: "#/properties/patientInformation/properties/city",
                                },
                                {
                                    type: "Control",
                                    label: "State",
                                    scope: "#/properties/patientInformation/properties/state",
                                },
                                {
                                    type: "Control",
                                    label: "Zip Code",
                                    scope: "#/properties/patientInformation/properties/zipCode",
                                },
                            ],
                        },
                        {
                            type: "Control",
                            scope: "#/properties/patientInformation/properties/phoneNumber",
                            label: "Phone Number",
                        },
                    ],
                },
            ],
        },
        {
            type: "Group",
            label: "Insurance Information",
            elements: [
                {
                    type: "VerticalLayout",
                    elements: [
                        {
                            type: "Control",
                            label: "Payment Method",
                            scope: "#/properties/insuranceInformation/properties/policyType",
                            options: {
                                format: "radio",
                            },
                        },
                        {
                            type: "HorizontalLayout",
                            elements: [
                                {
                                    type: "Control",
                                    scope: "#/properties/insuranceInformation/properties/mbi",
                                },
                            ],
                            rule: {
                                effect: "SHOW",
                                condition: {
                                    scope: `#/properties/insuranceInformation/properties/policyType`,
                                    schema: {
                                        const: "Medicare",
                                    },
                                },
                            },
                        },
                        {
                            type: "HorizontalLayout",
                            elements: [
                                {
                                    type: "Control",
                                    scope: "#/properties/insuranceInformation/properties/policyProvider",
                                },
                                {
                                    type: "Control",
                                    scope: "#/properties/insuranceInformation/properties/policyNumber",
                                },
                            ],
                            rule: {
                                effect: "SHOW",
                                condition: {
                                    scope: `#/properties/insuranceInformation/properties/policyType`,
                                    schema: {
                                        const: "Managed Medicare",
                                    },
                                },
                            },
                        },
                    ],
                },
            ],
        },
    ],
};
exports.default = labRequisitionUiSchema;
